import { Component, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { UserService } from '@app/core/user/user.service';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.scss']
})
export class PrincipalComponent implements OnInit {

  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'body-principal');
    // miramos a ver si obligamos a cambiar la clave
    const user = this.authService.getUser();
    if (user.passwordChangeRequired) {
      this.userService.openChangePassword(true, true);
    }
  }

}
